import { Navigate, Outlet } from "react-router-dom";

import { useInitApp } from "hooks/useInitApp";

export const ProtectedRoute = ({ children }) => {
    useInitApp();

    const userData = window.localStorage.getItem("token");

    if (
        !userData ||
        typeof userData === "undefined" ||
        typeof userData === "null"
    ) {
        const pathname = window.location.pathname;
        const search = window.location.search;
        if (pathname !== "/login" && pathname !== "/") {
            localStorage.setItem("to", pathname);
            search && localStorage.setItem("search", search);
        }

        //window.location.href = process.env.REACT_APP_PRO_MODE;
        return <Navigate replace to="/login" />;
    }

    return children ? children : <Outlet />;
};
